module.exports={
   "firebase": {
      "apiKey": "AIzaSyCUo2kE2G9ko_JgLCH4lDVF6pYUNNn1hcg",
      "authDomain": "form-engine-92d38.firebaseapp.com",
      "databaseURL": "https://form-engine-92d38.firebaseio.com",
      "projectId": "form-engine-92d38",
      "storageBucket": "form-engine-92d38.appspot.com",
      "messagingSenderId": "1096998861186",
      "functionsBaseUrl": "https://api-dev.formengine.com",
      "localPort": 5001
   }
}